import { CARDS_TOPUPMODES, CARDS_TYPE_EMITTER, CARDS_TYPE, CARDS_PRODUCT } from '@/assets/constants/cards'

export const cardsTopupForOperations = {
	CARDS_CHARGE_DIRECT_KAMBA: [CARDS_TOPUPMODES.KAMBA_DIRECT_TOPUP],
    CARDS_CHARGE_FLEX: [CARDS_TOPUPMODES.FLEX_TOPUP],
	CARDS_CHARGE_MULTICAIXA: [CARDS_TOPUPMODES.MCX_DIRECT_TOPUP],
	CARDS_CHARGE_VIRTUAL: [CARDS_TOPUPMODES.VIRTUAL_DIRECT_TOPUP],
    CARDS_TRANSFERS_FLEX: [CARDS_TOPUPMODES.FLEX_TOPUP]
}

export const cardsTypeEmitterForOperations = {
    CARDS_CARDLESS_WITHDRAW_GENERATE_CODE: [CARDS_TYPE_EMITTER.EMISMCX],
    CARDS_CARDLESS_WITHDRAW_MY_CODES: [CARDS_TYPE_EMITTER.EMISMCX],
	CARDS_BLOCK: [CARDS_TYPE_EMITTER.EMISMCX],
	CARDS_LIMITS: [CARDS_TYPE_EMITTER.EMISMCX]
}

export const cardsTypeForOperations = {
    CARDS_ANTICIPATE_PAYMENT: [CARDS_TYPE.BAICARD],
	CARDS_CHANGE_PAYMENT: [CARDS_TYPE.BAICARD]
}

export const cardsProductForOperations = {
    CARDS_CARDLESS_WITHDRAW_GENERATE_CODE: [CARDS_PRODUCT.N_PERS_EMV, CARDS_PRODUCT['N-PERS-EMV']],
    CARDS_CARDLESS_WITHDRAW_MY_CODES: [CARDS_PRODUCT.N_PERS_EMV, CARDS_PRODUCT['N-PERS-EMV']],
	CARDS_CHANGE_PAYMENT: [CARDS_PRODUCT.MCX_CREDIT, CARDS_PRODUCT.EMP_MCX_CR],
	CARDS_ANTICIPATE_PAYMENT: [CARDS_PRODUCT.MCX_CREDIT, CARDS_PRODUCT.EMP_MCX_CR],
    CARDS_LIMITS: [CARDS_PRODUCT.PERSON_EMV, CARDS_PRODUCT.N_PERS_EMV],
	CARDS_BLOCK: [CARDS_PRODUCT.PERSON_EMV, CARDS_PRODUCT.N_PERS_EMV]
}

/* Generating card text for dropdown display */
export const cardImageTextCreator = productName => {
    const defaultText = 'BAI card'

    const imageText = {
        'CRT-VISAPP': 'kamba',
        VISA_KAMBA: 'kamba',
        VISA_KAMB0: 'kamba',
        VISA_PLATI: 'platinum',
        VISA_CLASS: 'classic',
        VISA_GOLD: 'gold',
        VISA_BUSI: 'business',
        PERSON_EMV: 'multicaixa',
        N_PERS_EMV: 'multicaixa',
        N_PER_SNL: 'flex',
        PER_SONANG: 'flex',
        C_FLEX_EMV: 'flex',
        MCX_CREDIT: 'crédito',
        EMP_MCX_CR: 'empresas',
        MCX_PPNP: 'pré-pago',
        MCX_PPNP_: 'pré-pago',
        PRE_PAGO: 'pré-pago',
        PERSONALIZADO_MCX: 'pré-pago',
        CVISA_VIRT: 'virtual',
		CORPMSCARD: 'corporativo'
    }

    return imageText[productName] || defaultText
}

/* Generating card class for card gradient display */
export const cardClassCreator = productName => {
	const defaultClassName = 'generic-card'

	const className = {
        'CRT-VISAPP': 'kamba-card',
        VISA_KAMBA: 'kamba-visa-card',
        VISA_KAMB0: 'kamba-visa-card',
        VISA_PLATI: 'platinum-card',
        VISA_CLASS: 'classic-card',
        VISA_GOLD: 'gold-card',
        VISA_BUSI: 'business-card',
        N_PER_SNL: 'flex-card',
        PER_SONANG: 'flex-card',
        C_FLEX_EMV: 'flex-emv-card',
        MCX_CREDIT: 'mcx-card',
        EMP_MCX_CR: 'mcx-emp-card',
        MCX_PPNP: 'mcx-pre-paid-card',
        MCX_PPNP_: 'mcx-pre-paid-card',
        PRE_PAGO: 'mcx-pre-paid-card',
        PERSONALIZADO_MCX: 'mcx-pre-paid-card',
        CVISA_VIRT: 'virtual-card',
		CORPMSCARD: 'corporativo-card'
    }

	return className[productName] || defaultClassName
}

export const cardNegativeStatusMapper = statusCode => {
	switch (statusCode) {
	case 'FS_2': // Perdido
	case 'FS_3': // Roubado
	case 'FS_4': // Restrito
	case 'FS_8': // Comprometido
	case 'FS_9 ': // Fechado
	case 'FS_10': // Referência necessária
	case 'FS_15': // Expirado
    case 'GENERATING': // Em estado de geração
		return true
	default:
		return false
	}
}
